import dayjs, { Dayjs } from 'dayjs';
import { isEmpty, isNull, isUndefined } from 'lodash';
import { TransitsArchiveFilterKey, TransitsArchiveFilterValues } from 'store/wim/types/transits';

const isValueSignificant = (value: unknown): boolean => !isEmpty(value) || !isUndefined(value) || !isNull(value);

export const queryParamsToFilterValues = (filterValues: {
  [key: string]: any;
}): Partial<TransitsArchiveFilterValues> => {
  return Object.keys(filterValues).reduce((acc, currentFilterValueKey) => {
    if (isValueSignificant(filterValues[currentFilterValueKey])) {
      acc[currentFilterValueKey as keyof TransitsArchiveFilterValues] = filterValues[currentFilterValueKey];
    }
    if (currentFilterValueKey === TransitsArchiveFilterKey.wimIds) {
      acc[currentFilterValueKey] = filterValues[currentFilterValueKey];
    }
    if (currentFilterValueKey === TransitsArchiveFilterKey.start) {
      acc[currentFilterValueKey] = filterValues[currentFilterValueKey]
        ? dayjs(parseInt(filterValues[currentFilterValueKey], 10)).valueOf()
        : dayjs().subtract(1, 'hour').valueOf();
    }

    if (currentFilterValueKey === TransitsArchiveFilterKey.end) {
      acc[currentFilterValueKey] = filterValues[currentFilterValueKey]
        ? dayjs(parseInt(filterValues[currentFilterValueKey], 10)).valueOf()
        : dayjs().valueOf();
    }
    if (currentFilterValueKey === TransitsArchiveFilterKey.notWorkedDates) {
      acc[currentFilterValueKey] = filterValues[currentFilterValueKey]
        ? filterValues[currentFilterValueKey].map((value: string) => dayjs(parseInt(value, 10)))
        : [];
    }
    if (
      currentFilterValueKey === TransitsArchiveFilterKey.plateRecognized ||
      currentFilterValueKey === TransitsArchiveFilterKey.plateBackRecognized
    ) {
      acc[currentFilterValueKey] = !!filterValues[currentFilterValueKey];
    }
    if (currentFilterValueKey === TransitsArchiveFilterKey.vendorErrorsPresence) {
      const booleansByQueryValue: Record<string, boolean> = { true: true, false: false };
      acc[currentFilterValueKey] = booleansByQueryValue[String(filterValues[currentFilterValueKey])];
    }

    return acc;
  }, {} as Partial<TransitsArchiveFilterValues>);
};
